// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table.print-friendly tr td,table.print-friendly tr th{page-break-inside:avoid}", ""]);
// Exports
module.exports = exports;
